import { render, staticRenderFns } from "./AppraisalRecordEdit.vue?vue&type=template&id=ca297c48"
import script from "./AppraisalRecordEdit.vue?vue&type=script&lang=js"
export * from "./AppraisalRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports